/* eslint-disable import/extensions */
/* eslint-disable import/no-extraneous-dependencies */
// @decorators https://www.npmjs.com/package/reflect-metadata
import 'reflect-metadata';
import { Container } from 'inversify';
import { Logger, LogType, InjectionSymbols } from '@hitiq/logger';
// import { IAuthenticator, InjectionSymbols } from '@hitiq/auth';
// import { Authenticator } from '@hitiq/auth-amplify';
// import { queryParamModule } from './inversify.queryParams';
import { datadogLogs } from '@datadog/browser-logs';
import { GlobalQueryService } from './queryParams/global.query.service';
import { PlayerProfilePageQueryService } from '../pages/playerProfile/playerProfilePage.queryParam.service';
import { AmplifyDataStore } from './dataStorePersistence/AmplifyDataStore';
import {
  DataStoreModel,
  // InjectionSymbols as DataStoreInjectionSymbols,
} from './dataStorePersistence/DataStoreModel';
import {
  PlayerRepository,
  TeamRepository,
  AssessmentRepository,
  IncidentRepository,
  UserRepository,
  AccountsRepository,
  NotificationRepository,
} from './reduxRepositories';

import { RegionService } from './reduxRepositories/region/region.service';

import { schema } from './schema';
import { LoginDomainService } from '../pages/login/loginDomainService';
import { AuthService } from './helperServices/auth/auth.service';
import { AssessmentQueryParamService } from '../clinicApp/pages/assessment/assessment.queryParam.service';
import { UserQueryParamService } from '../pages/user/user.queryParam.service';
import { CreateIncidentQueryService } from '../pages/createIncident/createIncident.queryParam.service';
import { IncidentStepperService } from '../pages/createIncident/incidentStepper.queryParam.service';
import { LoginQueryParamService } from '../pages/login/login.queryParam.service';
import { AssessmentCreationViewService } from '../clinicApp/pages/assessment/assessmentCreationView/assessmentCreation.view.service';
import { TakeAssessmentDomain } from '../clinicApp/pages/assessment/takeAssessment/takeAssessmentDomainService';
import { ConneqtPageQueryService } from '../pages/conneqt/conneqt.queryParam.service';
import { ConneqtRepository } from './reduxRepositories/conneqt/conneqtRepository';
import { ConneqtPlayerDomain } from '../pages/conneqt/conneqtPlayer.domain';
import { PlayersPageQueryService } from '../pages/players/playersPage.queryParam.service';
import { ListTeamsQueryParamService } from '../orgApp/pages/listTeams/listTeams.queryParam.service';
import { ModulesSpecsDomain } from '../clinicApp/pages/assessment/takeAssessment/modules/modules.domain';
import { VomsDomainService } from '../clinicApp/pages/assessment/takeAssessment/modules/voms/voms.domain';
import { ListTeamDomainService } from '../orgApp/pages/listTeams/listTeamsDomainService';
import { awsConfig } from './aws-exports';
import { dataStoreTypeNames } from './store';
import { DatadogLogger } from './logger/datadogLogger';
import { version } from '../version';
import { datadogConfig } from './logger/datadogConfig';
import { ConsoleLogger } from './logger/consoleLogger';
import { CreateIncidentDomainService } from '../pages/createIncident/createIncidentDomainService';
import { IncidentCreationViewServices } from '../pages/createIncident/viewServices/createIncident.view.services';
import { AssessmentSummaryHelper } from '../clinicApp/pages/assessment/summary/summary.helper';
import { AssessmentDomainService } from '../clinicApp/pages/assessment/assessmentDomainService';
import { IncidentListDomainService } from '../pages/incidentsList/incidentListDomainService';
import { PlayerProfileDomain } from '../pages/playerProfile/playerProfile.domain';
import { IncidentListQueryService } from '../pages/incidentsList/incidentList.queryParam.service';
import { ViewIncidentQueryService } from '../pages/viewIncident/viewIncident.queryParam.service';
import { ViewIncidentDomainService } from '../pages/viewIncident/viewIncidentDomainService';
import { AssessmentSummaryQueryService } from '../pages/assessmentSummary/assessmentSummary.queryParam.service';
import { AssessmentSummaryDomain } from '../pages/assessmentSummary/assessmentSummary.domain';
import { AppointmentDomain } from '../guardianApp/components/Appointment/appointment.domain';
import { IncidentDomain } from '../domains/incident.domain';
import { ConneqtNewPlayerDomain } from '../pages/conneqt/recieved/conneqtNewPlayer.domain';
import { AddPlayerViewService } from '../pages/players/addPlayer.view.service';
import { AddPlayerDomain } from '../pages/players/addPlayer.domain';
import { ConneqtOnAddPlayerDomain } from '../pages/players/addConneqtModal/conneqtOnAddPlayer.domain';
import { AddNewPlayerView } from '../pages/conneqt/recieved/addNewPlayer.view.service';
import { ReceivedConneqtDomain } from '../pages/conneqt/recieved/receivedConneqts.domain';
import { AddConneqtView } from '../pages/conneqt/addConneqt/addConneqt.view.service';
import { AddConneqtDomain } from '../pages/conneqt/addConneqt/addConneqt.domain';
import { SentConneqtDomain } from '../pages/conneqt/sent/sentConneqt.domain';
import { AllConneqtsDomain } from '../pages/conneqt/allConneqtRequests/allConneqts.domain';
import { RegionDomain } from '../domains/region.domain';
import { ThemeService } from '../components/toggleThemeSwitch/theme.service';
import { ThemeDomain } from '../components/toggleThemeSwitch/theme.domain';
import { ManageTeamDomainService } from '../orgApp/pages/team/manageTeamDomainService';
import { DownloadPlayerTemplateService } from './reduxRepositories/downloadPlayerTemplate/downloadPlayerTemplate.services';
import { SymptomAssessmentDomainService } from '../pages/symptomAssessment/symptomAssessmentDomainService';
import { UserDomainService } from '../pages/user/userDomainService';

const di = new Container({ skipBaseClassChecks: true });

// diContainer.load(queryParamModule);

// diContainer.unload(queryParamModule);

// AUTH
// Amplify.configure(aws);

// const authenticator = new Authenticator(aws);

// di.bind<IAuthenticator>(InjectionSymbols.AUTHENTICATOR)
//   .toDynamicValue(() => {
//     return authenticator;
//   })
//   .inSingletonScope();

if (process.env.NODE_ENV === 'production') {
  datadogLogs.init({
    clientToken: datadogConfig.clientId,
    forwardErrorsToLogs: true,
    sessionSampleRate: 100,
    service: 'conneqt',
    version,
  });
}

di.bind<Logger>(InjectionSymbols.LOGGER)
  .toDynamicValue(() =>
    !process.env.NODE_ENV || process.env.NODE_ENV === 'development'
      ? new ConsoleLogger()
      : new DatadogLogger('AUTH', LogType.debug),
  )
  .inSingletonScope();

di.bind<AuthService>(AuthService).to(AuthService).inSingletonScope();

di.bind<LoginDomainService>(LoginDomainService)
  .to(LoginDomainService)
  .inSingletonScope();

// REPOSITORIES
di.bind<AmplifyDataStore<DataStoreModel>>(AmplifyDataStore)
  .toDynamicValue(() => {
    const logger = di.get<Logger>(InjectionSymbols.LOGGER);
    // QUESTION: could this be why AmplifyDataStore is initiated multiple times on rebuild, etc?
    return new AmplifyDataStore(schema, dataStoreTypeNames, awsConfig, logger);
  })
  .inSingletonScope();

di.bind<UserRepository>(UserRepository).to(UserRepository).inSingletonScope();

di.bind<AccountsRepository>(AccountsRepository)
  .to(AccountsRepository)
  .inSingletonScope();

di.bind<AssessmentRepository>(AssessmentRepository)
  .to(AssessmentRepository)
  .inSingletonScope();

di.bind<IncidentRepository>(IncidentRepository)
  .to(IncidentRepository)
  .inSingletonScope();

di.bind<NotificationRepository>(NotificationRepository)
  .to(NotificationRepository)
  .inSingletonScope();

di.bind<PlayerRepository>(PlayerRepository)
  .to(PlayerRepository)
  .inSingletonScope();

di.bind<TeamRepository>(TeamRepository).to(TeamRepository).inSingletonScope();

di.bind<ConneqtRepository>(ConneqtRepository)
  .to(ConneqtRepository)
  .inSingletonScope();

// QUERY PARAMS
di.bind<GlobalQueryService>(GlobalQueryService)
  .to(GlobalQueryService)
  .inSingletonScope();
di.bind<PlayersPageQueryService>(PlayersPageQueryService)
  .to(PlayersPageQueryService)
  .inSingletonScope();
di.bind<ListTeamsQueryParamService>(ListTeamsQueryParamService)
  .to(ListTeamsQueryParamService)
  .inSingletonScope();
di.bind<ConneqtPageQueryService>(ConneqtPageQueryService)
  .to(ConneqtPageQueryService)
  .inSingletonScope();
di.bind<PlayerProfilePageQueryService>(PlayerProfilePageQueryService)
  .to(PlayerProfilePageQueryService)
  .inSingletonScope();
di.bind<AssessmentQueryParamService>(AssessmentQueryParamService)
  .to(AssessmentQueryParamService)
  .inSingletonScope();
di.bind<AssessmentSummaryQueryService>(AssessmentSummaryQueryService)
  .to(AssessmentSummaryQueryService)
  .inSingletonScope();
di.bind<UserQueryParamService>(UserQueryParamService)
  .to(UserQueryParamService)
  .inSingletonScope();

// Incident
di.bind<IncidentStepperService>(IncidentStepperService)
  .to(IncidentStepperService)
  .inSingletonScope();

di.bind<CreateIncidentQueryService>(CreateIncidentQueryService)
  .to(CreateIncidentQueryService)
  .inSingletonScope();

di.bind<ViewIncidentQueryService>(ViewIncidentQueryService)
  .to(ViewIncidentQueryService)
  .inSingletonScope();

di.bind<IncidentListQueryService>(IncidentListQueryService)
  .to(IncidentListQueryService)
  .inSingletonScope();

di.bind<LoginQueryParamService>(LoginQueryParamService)
  .to(LoginQueryParamService)
  .inSingletonScope();

di.bind<CreateIncidentDomainService>(CreateIncidentDomainService)
  .to(CreateIncidentDomainService)
  .inSingletonScope();

di.bind<ViewIncidentDomainService>(ViewIncidentDomainService)
  .to(ViewIncidentDomainService)
  .inSingletonScope();

di.bind<IncidentCreationViewServices>(IncidentCreationViewServices)
  .to(IncidentCreationViewServices)
  .inSingletonScope();

di.bind<IncidentDomain>(IncidentDomain).to(IncidentDomain).inSingletonScope();

// ASSESSMENTS
di.bind<AssessmentCreationViewService>(AssessmentCreationViewService)
  .to(AssessmentCreationViewService)
  .inSingletonScope();
di.bind<TakeAssessmentDomain>(TakeAssessmentDomain)
  .to(TakeAssessmentDomain)
  .inSingletonScope();
di.bind<ModulesSpecsDomain>(ModulesSpecsDomain)
  .to(ModulesSpecsDomain)
  .inSingletonScope();
di.bind<VomsDomainService>(VomsDomainService)
  .to(VomsDomainService)
  .inSingletonScope();
di.bind<AssessmentSummaryHelper>(AssessmentSummaryHelper)
  .to(AssessmentSummaryHelper)
  .inSingletonScope();
di.bind<AssessmentSummaryDomain>(AssessmentSummaryDomain)
  .to(AssessmentSummaryDomain)
  .inSingletonScope();
di.bind<AppointmentDomain>(AppointmentDomain)
  .to(AppointmentDomain)
  .inSingletonScope();

// Conneqt Page
di.bind<ConneqtPlayerDomain>(ConneqtPlayerDomain)
  .to(ConneqtPlayerDomain)
  .inSingletonScope();
di.bind<ReceivedConneqtDomain>(ReceivedConneqtDomain)
  .to(ReceivedConneqtDomain)
  .inSingletonScope();
di.bind<SentConneqtDomain>(SentConneqtDomain)
  .to(SentConneqtDomain)
  .inSingletonScope();
di.bind<AllConneqtsDomain>(AllConneqtsDomain)
  .to(AllConneqtsDomain)
  .inSingletonScope();
di.bind<ConneqtNewPlayerDomain>(ConneqtNewPlayerDomain)
  .to(ConneqtNewPlayerDomain)
  .inSingletonScope();
di.bind<AddConneqtDomain>(AddConneqtDomain)
  .to(AddConneqtDomain)
  .inSingletonScope();
di.bind<AddConneqtView>(AddConneqtView).to(AddConneqtView).inSingletonScope();

// symptom assessment
di.bind<SymptomAssessmentDomainService>(SymptomAssessmentDomainService)
  .to(SymptomAssessmentDomainService)
  .inSingletonScope();

di.bind<AssessmentDomainService>(AssessmentDomainService)
  .to(AssessmentDomainService)
  .inSingletonScope();
di.bind<ListTeamDomainService>(ListTeamDomainService)
  .to(ListTeamDomainService)
  .inSingletonScope();

di.bind<IncidentListDomainService>(IncidentListDomainService)
  .to(IncidentListDomainService)
  .inSingletonScope();

// Player Profile Page
di.bind<PlayerProfileDomain>(PlayerProfileDomain)
  .to(PlayerProfileDomain)
  .inSingletonScope();

// Players page
di.bind<AddPlayerViewService>(AddPlayerViewService)
  .to(AddPlayerViewService)
  .inSingletonScope();
di.bind<AddPlayerDomain>(AddPlayerDomain)
  .to(AddPlayerDomain)
  .inSingletonScope();
di.bind<ConneqtOnAddPlayerDomain>(ConneqtOnAddPlayerDomain)
  .to(ConneqtOnAddPlayerDomain)
  .inSingletonScope();
di.bind<AddNewPlayerView>(AddNewPlayerView)
  .to(AddNewPlayerView)
  .inSingletonScope();
di.bind<DownloadPlayerTemplateService>(DownloadPlayerTemplateService)
  .to(DownloadPlayerTemplateService)
  .inSingletonScope();

// Region
di.bind<RegionDomain>(RegionDomain).to(RegionDomain).inSingletonScope();
di.bind<RegionService>(RegionService).to(RegionService).inSingletonScope();
di.bind<ManageTeamDomainService>(ManageTeamDomainService)
  .to(ManageTeamDomainService)
  .inSingletonScope();

// Theme
di.bind<ThemeDomain>(ThemeDomain).to(ThemeDomain).inSingletonScope();
di.bind<ThemeService>(ThemeService).to(ThemeService).inSingletonScope();

// User Page
di.bind<UserDomainService>(UserDomainService)
  .to(UserDomainService)
  .inSingletonScope();

// diContainer
//   .bind<EmailDataService>(EmailDataService)
//   .to(EmailDataService)
//   .inSingletonScope();

// diContainer
//   .bind<PermissionDataService>(PermissionDataService)
//   .to(PermissionDataService)
//   .inSingletonScope();

export { di };
